import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import jwt from 'jsonwebtoken';

import { SmlsButton } from '@smiles/smiles-ui-kit-react';
import { getMember, updateMember } from 'services/core/services';
import { Config } from '@smiles/core-engine';
import { AddressType, CellPhoneType } from '@smiles/core-account/dist/Types/CommonTypes';
import { loginLiferay } from 'utils/liferay';
import { Header } from './Header';
import { DocumentImage } from './assets/DocumentImage';
import { EmailSmallIcon } from './assets/EmailSmallIcon';
import { PhoneSmallIcon } from './assets/PhoneSmallIcon';

interface MemberModel {
  address: AddressType;
  cellPhone: CellPhoneType;
  email: string;
  firstName: string;
}

export const CobrandedConfirm: React.FC = () => {
  const JWT_COOKIE_NAME = process.env.REACT_APP_TOKEN_NAME || 'session-token';

  const location = window.location.origin;
  const upd = new Date().getTime();
  const redirectHome = `${location}/home?upd=${upd}`;
  const redirectMyAccount = `${location}/restrito/minha-conta/alterar-dados?upd=${upd}`;

  const { t: register } = useTranslation('confirm_register');

  const [cookies, , removeCookie] = useCookies([JWT_COOKIE_NAME]);

  const [member, setMember] = useState<MemberModel>();
  const [loadConfirmRegister, setLoadConfirmRegister] = useState<boolean>(false);

  const token: string = cookies[JWT_COOKIE_NAME] || '';
  const decoded = jwt.decode(token);

  const setClassMainPortal = useCallback(async () => {
    const getMainPortal = document.querySelector('.main-portal');
    await loginLiferay(token, decoded);
    return getMainPortal?.classList?.add('main__portal--container');
  }, []);

  const getMemberData = useCallback(async (): Promise<void> => {
    const { data, success } = await getMember();

    if (true) {
      setMember(data);
    } else {
      window.location.href = redirectHome;
    }
  }, [member]);

  const clearToken = () => {
    removeCookie(JWT_COOKIE_NAME, { path: '/' });
  };

  const onReviewRegister = useCallback(async () => {
    clearToken();
    window.location.href = redirectMyAccount;
  }, [cookies, member]);

  const onConfirmRegister = useCallback(async () => {
    setLoadConfirmRegister(true);
    await updateMember({
      contactType: 'EMAIL',
      regularData: {
        address: {
          ...(member?.address as AddressType),
        },
        email: String(member?.email),
        acceptTerms: {
          accepted: true,
          termsOpened: false,
        },
      },
    });
    clearToken();
    window.location.href = redirectHome;
  }, [member]);

  useEffect(() => {
    setClassMainPortal();
    localStorage.setItem(JWT_COOKIE_NAME, token);
    sessionStorage.setItem(JWT_COOKIE_NAME, token);
    Config.saveTokenAuthUser({ accessToken: token });
    setTimeout(async () => {
      await getMemberData();
    }, 1050);
  }, []);

  return (
    <div className="confirm-register-wrapper">
      <Header />
      <div className="confirm-register-tangie-container">
        <div className="confirm-register-tangie-main-content" style={{ maxWidth: '440px' }}>
          <div className="display-image">
            <DocumentImage />
          </div>
          <h3>{`${String(member?.firstName)}, você precisa revisar seus dados`}</h3>
          <p>Vamos enviar informações importantes como seu saldo e atualizações de viagem.</p>

          <div className="contact-list">
            <div className="contact-item">
              <div className="contact-item-image">
                <EmailSmallIcon />
              </div>
              <div>
                <strong>
                  <p>{String(member?.email)}</p>
                </strong>

                <span>E-mail</span>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item-image">
                <PhoneSmallIcon />
              </div>
              <div>
                <strong>
                  <p>{String(member?.cellPhone?.formatted?.display)}</p>
                </strong>

                <span>Telefone</span>
              </div>
            </div>
          </div>

          <div className="button-footer">
            <SmlsButton
              data-testid="onConfirmRegister"
              text={register('button_secondary')}
              color="hyperlink"
              isLoading={loadConfirmRegister}
              onClick={onConfirmRegister}
            />

            <SmlsButton
              data-testid="onReviewRegister"
              text={register('button_primary')}
              disabled={loadConfirmRegister}
              onClick={onReviewRegister}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
